/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithTokenItemRequestBuilder, WithTokenItemRequestBuilderNavigationMetadata, WithTokenItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares/directories
 */
export interface DirectoriesRequestBuilder extends BaseRequestBuilder<DirectoriesRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.shares.directories.item collection
     * @param token Unique identifier of the item
     * @returns {WithTokenItemRequestBuilder}
     */
     byToken(token: string) : WithTokenItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DirectoriesRequestBuilderUriTemplate = "{+baseurl}/shares/directories";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DirectoriesRequestBuilderNavigationMetadata: Record<Exclude<keyof DirectoriesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byToken: {
        requestsMetadata: WithTokenItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithTokenItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["token"],
    },
};
/* tslint:enable */
/* eslint-enable */
